import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { NguiMapModule, NguiMapComponent } from "@ngui/map";

// NgRx (Redux)
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { appReducers } from "./app.reducers";

import { AppRoutingModule, routes } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { RegisterComponent } from "./login/register/register.component";
import { RegisterinterComponent } from "./login/registerinter/registerinter.component";
import { ConfigService } from "./app.config";
import { LoginComponent } from "./login/login/login.component";
import { RecoverComponent } from "./login/recover/recover.component";
import { ProjectDetailComponent } from "./admin/project-detail/project-detail.component";
import { ProjectListComponent } from "./admin/project-list/project-list.component";
import { UserDetailComponent } from "./admin/user-detail/user-detail.component";
import { UserListComponent } from "./admin/user-list/user-list.component";

import { AdminGuard } from "./admin/admin.Guard";
import { LoginGuard } from "./login/login.Guard";
import { CanvasRendererGuards } from "./builder/canvas-renderer/canvas-renderer.Guards";
import { GmapsRendererGuards } from "./builder/gmaps-renderer/gmaps-renderer.Guards";
import { ProjectDetailGuards } from "./admin/project-detail/project-detail.guard";
import { ProjectListGuards } from "./admin/project-list/project-list.guard";
import { UserDetailGuards } from "./admin/user-detail/user-detail.guard";

import { GmapsRendererComponent } from "./builder/gmaps-renderer/gmaps-renderer.component";
import { CanvasRendererComponent } from "./builder/canvas-renderer/canvas-renderer.component";
import { SettingsboxComponent } from "./builder/settingsbox/settingsbox/settingsbox.component";
import { DoorPickerComponent } from "./builder/settingsbox/door-picker/door-picker.component";
import { ProductPickerComponent } from "./builder/settingsbox/product-picker/product-picker.component";
import { AlertComponent } from "./alert/alert.component";
import { NewProjectComponent } from "./new-project/new-project.component";
import { ColorComponent } from "./color/color.component";
import { LoaderComponent } from "./loader/loader.component";
import { NoContentComponent } from "./no-content/no-content.component";
import { HoldComponent } from "./hold/hold.component";
import { Scheme2Component } from "./builder/scheme2/scheme2.component";
import { Scheme3dComponent } from "./builder/scheme3d/scheme3d.component";
import { Satelite3dComponent } from "./builder/satelite3d/satelite3d.component";

import { BuilderService } from "./builder/builder.service";

import { ProjectStatusPipe } from "./pipes/project-status.pipe";

import {
	RouterModule,
	PreloadAllModules,
	RouteReuseStrategy,
} from "@angular/router";
import { FileUploadModule } from "ng2-file-upload";
import { UiSwitchModule } from "ngx-ui-switch";
import { CustomReuseStrategy } from "./app.reuse";
import { Daterangepicker } from "ng2-daterangepicker";
import { LegaltextComponent } from "./legaltext/legaltext.component";

import { environment } from "src/environments/environment";

const googleApiURL: string =
	"http://maps.google.com/maps/api/js?v=weekly" +
	"&libraries=visualization,places,geometry,drawing" +
	"&key=" +
	ConfigService.GOOGLE_API_KEY;

@NgModule({
	declarations: [
		AppComponent,
		RegisterComponent,
		RegisterinterComponent,
		LoginComponent,
		RecoverComponent,
		ProjectDetailComponent,
		ProjectListComponent,
		UserDetailComponent,
		UserListComponent,
		CanvasRendererComponent,
		SettingsboxComponent,
		DoorPickerComponent,
		ProductPickerComponent,
		AlertComponent,
		NewProjectComponent,
		ColorComponent,
		ProjectStatusPipe,
		LoaderComponent,
		ProjectStatusPipe,
		NoContentComponent,
		HoldComponent,
		Scheme2Component,
		Scheme3dComponent,
		Satelite3dComponent,
		LegaltextComponent,
		GmapsRendererComponent,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		FormsModule,
		RouterModule.forRoot(routes, {
			useHash: true,
			preloadingStrategy: PreloadAllModules,
			relativeLinkResolution: "legacy",
		}),
		NguiMapModule.forRoot({ apiUrl: googleApiURL }),
		ReactiveFormsModule,
		FileUploadModule,
		UiSwitchModule,
		Daterangepicker,
		StoreModule.forRoot(appReducers),
		StoreDevtoolsModule.instrument({
			maxAge: 25, // Retains last 25 states
			logOnly: environment.production, // Restrict extension to log-only mode
		}),
	],
	providers: [
		AdminGuard,
		LoginGuard,
		BuilderService,
		{ provide: RouteReuseStrategy, useClass: CustomReuseStrategy },
		CanvasRendererGuards,
		GmapsRendererGuards,
		ProjectDetailGuards,
		ProjectListGuards,
		UserDetailGuards,
		NguiMapComponent,
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
